///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../common/data-template-base.ts"/>
///<reference path="../filter-templates/point-promotions.filter.ts"/>
///<reference path="../collections/report-employee-categories.collection.ts"/>
///<reference path="../collections/report-payroll-employees.collection.ts"/>
///<reference path="report-employee-secure.ts"/>
///<reference path="../collection-population-strategies/payroll-employee-to-categories.strategy.ts"/>
///<reference path="../validation/payroll-employees.validation.ts"/>


module Meevo.Components.Controls.SmartMover {

    import Dictionary = _.Dictionary;

    export class ReportPayrollEmployee extends ReportSecureEmployeeDataTemplate implements ISecureDataTemplate {

        protected employeeCategories: ReportEmployeeCategoriesCollection;
        protected employees: ReportPayrollEmployeesCollection;

        get collection() {
            return this.employeeCategories;
        }

        get totalSelectedCount(): number {
            return this.employees.value.length;
        }

        constructor(model: Dictionary<any>, properties: string[], options?: IDataTemplateOptions) {
            super(model, properties, options);

            this.globalErrorMessage = '';

            this.employeeCategories = new ReportEmployeeCategoriesCollection(this.model[properties[0]], [], {
                criteria: options.criteria
            });
            this.employees = new ReportPayrollEmployeesCollection(this.model[properties[1]], [], {
                criteria: options.criteria
            });

            this.filters = [
                new ActiveInactiveFilter({hideInactiveLabel: 'LABEL_HIDE_INACTIVE_EMPLOYEES'})
            ];

            this.validation.push(
                new PayrollEmployeesValidation(this.employees, () => this.smartMoverHidden)
            );

            this.employees.setParentCollection(this.employeeCategories, PayrollEmployeeToCategoriesStrategy);
            this.employees.addFilters(...this.filters as IInteractiveFilter[]);
        }

        setWatchers(scope: angular.IScope) {
            this.employeeCategories.setWatchers(scope);
            this.employees.setWatchers(scope);
        }

        onSecurityFail(): void {
            this.model['hideAllSelectedCheckbox'] = true;
            this.smartMoverHidden = true;
        }

        onCriteriaUpdate(newCriteria: _.Dictionary<any>, $q: ng.IQService): ng.IPromise<any> {
            if (Model.Guard.isSomething(newCriteria["reportId"]) && newCriteria["reportId"] == 244){
                if (Model.Guard.isSomething(newCriteria["LocationForHierarchy"]) && newCriteria["LocationForHierarchy"].length > 0) {
                    this.employees.updateCriteria(newCriteria);
                    return this.employees.fetch();
                }
            }
            else {                
                if (Model.Guard.isSomething(newCriteria["PayrollPeriodList_TBL"])) {                 
                    this.employees.updateCriteria(newCriteria);
                    return this.employees.fetch();
                }
            }
        }
    }
}
